<template>
  <v-layout text-xs-center>
    <v-flex xs12>
      <v-card>
        <v-layout text-xs-center class="pt-3 pb-1 mb-1">
          <v-flex xs4>
            <v-avatar :size="43">
              <v-img :src="jobIcon" alt="avatar"></v-img>
            </v-avatar>
            <div class="caption">
              {{character.job.label}}
            </div>
          </v-flex>

          <v-flex xs3 class="mx-2 mt-2">
            <v-text-field height="25"
                          readonly
                          label="名前"
                          color="secondary"
                          :value="` ${character.name}`"></v-text-field>
          </v-flex>

          <v-flex xs2 class="mx-2 mt-2">
            <v-text-field height="25"
                          label="レベル"
                          color="secondary"
                          type="number"
                          v-model="character.level"></v-text-field>
          </v-flex>

          <v-flex xs1 class="mt-2">
            <button @click="addLevel()" class="plusButton px-3 py-1">＋</button>
            <button @click="minusLevel()" class="minusButton px-3 py-1">ー</button>
          </v-flex>
        </v-layout>

        <v-divider></v-divider>

        <v-layout text-xs-center justify-space-around class="mt-4">
          <v-flex xs4>武陵道場</v-flex>
          <v-flex xs4 class="mr-1">ネト</v-flex>
          <v-flex xs4><div class="mr-1">イベント</div></v-flex>
        </v-layout>
        <v-layout text-xs-center justify-space-around>
          <v-flex xs1 class="ml-1">
            <v-checkbox v-model="character.check.dojo" color="secondary"></v-checkbox>
          </v-flex>
          <v-flex xs1>
            <v-checkbox v-model="character.check.neto" color="secondary"></v-checkbox>
          </v-flex>
          <v-flex xs1>
            <v-checkbox v-model="character.check.event" color="secondary"></v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout text-xs-center justify-space-around>
          <v-flex xs4>ペットのえさ</v-flex>
          <v-flex xs4>装備強化</v-flex>
          <v-flex xs4><div class="mr-1">戦闘チャージ</div></v-flex>
        </v-layout>
        <v-layout text-xs-center justify-space-around>
          <v-flex xs1 class="ml-1">
            <v-checkbox v-model="character.check.pet" color="secondary"></v-checkbox>
          </v-flex>
          <v-flex xs1>
            <v-checkbox v-model="character.check.equip" color="secondary"></v-checkbox>
          </v-flex>
          <v-flex xs1>
            <v-checkbox v-model="character.check.fight" color="secondary"></v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout text-xs-center justify-center class="pt-2">
          <v-flex xs2 class="mr-1">
            <v-text-field height="25"
                          readonly
                          label="自動戦闘"
                          color="secondary"
                          :value="` ${character.fight}  分`"></v-text-field>
          </v-flex>

          <v-flex xs6 class="ml-3">
            <v-slider
              v-model="character.fight"
              step="10"
              color="secondary"
              :min="0"
              :max="360"></v-slider>
          </v-flex>

          <v-flex xs2 class="ml-1 mt-1">
            <v-btn icon flat color="secondary" @click="addFight()">
              <v-icon>add_alarm</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: ['character', 'index'],
    data: () => ({
      jobIcon: require('../assets/job/no.png'),
    }),
    mounted: function () {
      this.jobIcon = require(`../assets/job/${this.character.job.value}.png`);
    },
    watch: {
      'character': {
        handler: function (val) {
          const local = JSON.parse(localStorage.getItem('characters'));
          local[this.index] = JSON.parse(JSON.stringify(this.character));
          localStorage.setItem('characters', JSON.stringify(local));
        },
        deep: true
      }
    },
    methods: {
      addFight: function () {
        this.character.fight += 120;
        this.character.check.fight = true;
      },
      addLevel: function () {
        this.character.level++;
      },
      minusLevel: function () {
        this.character.level--;
      }
    }
  }
</script>

<style>
.minusButton {
  color: #1E88E5
}
.plusButton {
  color: #D32F2F
}
</style>
